import React from 'react'

const ApprovedIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0491 8.27344H15.9499C15.7108 8.27344 15.4835 8.38828 15.3429 8.58516L11.6585 13.6945L9.98975 11.3789C9.84912 11.1844 9.62412 11.0672 9.38272 11.0672H8.2835C8.13116 11.0672 8.04209 11.2406 8.13116 11.3648L11.0515 15.4148C11.1205 15.5111 11.2114 15.5896 11.3168 15.6437C11.4221 15.6978 11.5389 15.7261 11.6573 15.7261C11.7758 15.7261 11.8925 15.6978 11.9979 15.6437C12.1033 15.5896 12.1942 15.5111 12.2632 15.4148L17.1991 8.57109C17.2905 8.44688 17.2015 8.27344 17.0491 8.27344Z"
        fill="#0FB680"
      />
      <path
        d="M12.666 1.5C6.86758 1.5 2.16602 6.20156 2.16602 12C2.16602 17.7984 6.86758 22.5 12.666 22.5C18.4645 22.5 23.166 17.7984 23.166 12C23.166 6.20156 18.4645 1.5 12.666 1.5ZM12.666 20.7188C7.85195 20.7188 3.94727 16.8141 3.94727 12C3.94727 7.18594 7.85195 3.28125 12.666 3.28125C17.4801 3.28125 21.3848 7.18594 21.3848 12C21.3848 16.8141 17.4801 20.7188 12.666 20.7188Z"
        fill="#0FB680"
      />
    </svg>
  )
}

export default ApprovedIcon
